/**
 * NOTE: This is a new set of video intent values, introduced Oct 13, 2026;
 * for details, see: https://github.com/moreheaddesign/soul-sanctuary/issues/263#issuecomment-6134733974
 */
export const VIDEO_INTENTS = [
  'Calm & Steadiness',
  'Confidence & Courage',
  'Connection & Openness',
  'Energy & Readiness',
  'Focus & Clarity',
  'Reflection & Direction',
  'Release & Recovery',
] as const;

export type VideoIntentT = typeof VIDEO_INTENTS[number];

/**
 * This also comes from https://github.com/moreheaddesign/soul-sanctuary/issues/263#issuecomment-6134733974
 * when selecting videos for an experience with given intent, all but the last
 * videos are selected from just the same intent group, rather than from that
 * specific intent, to keep the pool of potential matches larger.
 */
export const VIDEO_INTENT_GROUP_NAMES = [
  'Calming',
  'Energizing',
  'Steadying',
] as const;

export type VideoIntentGroupT = typeof VIDEO_INTENT_GROUP_NAMES[number];

/**
 * Map from intent to the intent group.
 */
export const VIDEO_INTENT_GROUP: Record<VideoIntentT, VideoIntentGroupT> = {
  'Calm & Steadiness': 'Calming',
  'Confidence & Courage': 'Steadying',
  'Connection & Openness': 'Steadying',
  'Energy & Readiness': 'Energizing',
  'Focus & Clarity': 'Steadying',
  'Reflection & Direction': 'Steadying',
  'Release & Recovery': 'Calming',
};

export const VIDEO_INTENT_GROUPS: Record<VideoIntentGroupT, VideoIntentT[]> = {
  Calming: [],
  Energizing: [],
  Steadying: [],
};

for (const [intent, group] of Object.entries(VIDEO_INTENT_GROUP)) {
  VIDEO_INTENT_GROUPS[group].push(intent as VideoIntentT);
}

export const DEPRECATED_VIDEO_INTENTS = [
  'Calm Anxiety',
  'Creativity Enhancement',
  'Emotional Reset',
  'Energy Activation',
  'Mood Uplift',
  'Muscle Recovery',
  'Self Connection',
  'Sleep Preparation',
  'Stress Relief',
  'Tension Release',
] as const;
